// src/configs/sceneConfigs.js
export const sceneConfigs = {
  "dong-thap": {
    image: "/images/dong-thap.jpg",
    view: {
      fov: 73.41,
      pitch: 5.93,
      yaw: -18.13,
    },
  },
  "an-giang": {
    image: "/images/an-giang.jpg",
    view: {
      fov: 73.41,
      pitch: 12.52,
      yaw: 3.13,
    },
  },
  "can-tho": {
    image: "/images/can-tho.jpg",
    view: {
      fov: 73.41,
      pitch: 18.23,
      yaw: 7.46,
    },
  },
  "vinh-long": {
    image: "/images/vinh-long.jpg",
    view: {
      fov: 73.41,
      pitch: 22.38,
      yaw: 3.89,
    },
  },
  "ca-mau": {
    image: "/images/ca-mau.jpg",
    view: {
      fov: 73.41,
      pitch: 4.45,
      yaw: 27.6,
    },
  },
};
